import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import CarnivalShell from './CarnivalShell';
import { GAMES } from './games';
import { isDemoSession } from './session';

// Demo players cannot play in production — they are sent to the plans page (game.php). Local development
// keeps demo players unlocked so the games can be tried without an ExtraMilePlay launcher.
const demoLocked = (session) => isDemoSession(session) && process.env.NODE_ENV === 'production';

// Games hub (game.php): welcome + points strip, then the four games.
export default function CarnivalHome() {
  const navigate = useNavigate();
  const { session, game } = useSelector((s) => s.carnival);
  const name = game?.name || session?.name;

  const open = (key) => {
    if (demoLocked(session)) {
      Swal.fire({ text: 'Subscribe to any plan to enjoy the MELA games.', icon: 'success' }).then(() => {
        window.location.href = `${process.env.REACT_APP_BASE_URL}/plans`;
      });
      return;
    }
    navigate(`/carnival/play/${key}`);
  };

  return (
    <CarnivalShell bg="/carnival/img/3rd-Screen-bg.gif" bgMob="/carnival/img/3rdscreen_mobile_BG.gif" className="cc-home">
      <div className="cc-scorebar">
        <div className="cc-scorebar-text">
          <span className="cc-welcome">Welcome {name}</span>
          <span className="cc-points">
            Total Points : <strong>{game?.points ?? 0}</strong>
          </span>
        </div>
      </div>

      <div className="cc-home-body">
        <img className="cc-description" src="/carnival/img/description.png" alt="Play all four games to collect points" />

        <div
          className="cc-board"
          style={{ "--cc-board": "url(/carnival/img/Rectangle.png)", "--cc-board-mob": "url(/carnival/img/Mobile_BG_BOX.png)" }}
        >
          {GAMES.map((g) => {
            return (
              <button key={g.key} type="button" className="cc-card" onClick={() => open(g.key)}>
                <img src={g.card} alt={g.title} />
              </button>
            );
          })}
        </div>
      </div>
    </CarnivalShell>
  );
}
